var _desc, _defs, _rect, _rect2, _g, _path, _path2, _g2, _g3, _g4, _g5, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 753 565",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Light generic map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A soft generic map with pale streets and neutral city blocks.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "paper",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: 0.018,
    numOctaves: 2,
    seed: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "saturate",
    values: 0.12
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "0 .05"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "softFade",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fbfaf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef4f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "parkGlow",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f6ed",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#bdffd5",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dff4e7",
    stopOpacity: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 753,
    height: 565,
    fill: "url(#softFade)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 753,
    height: 565,
    filter: "url(#paper)",
    opacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f7edd5",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 282H138V473H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 282H269V565H0V474H138Z",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 282H569V565H271V501L320 536L354 498V375H234V342H270Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 283H753V565H585Z",
    opacity: 0.55
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 468H271V565H74Z",
    fill: "url(#parkGlow)",
    opacity: 0.78
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196 474C228 462 254 475 272 503V565H114C126 526 151 489 196 474Z",
    fill: "#d7f4df",
    opacity: 0.36
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 0V565",
    stroke: "#c6d0d9",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 0V565",
    stroke: "#c6d0d9",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 0V565",
    stroke: "#c6d0d9",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 0V565",
    stroke: "#c6d0d9",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 0V565",
    stroke: "#c6d0d9",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 0V565",
    stroke: "#c6d0d9",
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 0V565",
    stroke: "#c6d0d9",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 95H753",
    stroke: "#c6d0d9",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 187H513C542 193 562 208 586 227L753 338",
    stroke: "#c6d0d9",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 197H506C532 199 554 214 579 234L753 358",
    stroke: "#edf2f5",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 282H753",
    stroke: "#c6d0d9",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 375H753",
    stroke: "#c6d0d9",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 471H753",
    stroke: "#c6d0d9",
    strokeWidth: 7
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c9d5de",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651 126L719 123V94H674",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 94V133H719",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 152H758",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 292L753 292",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733 214V254",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727 292V438",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708 469H753",
    strokeWidth: 4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 42,
    r: 175,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 285,
    r: 132,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 633,
    cy: 542,
    r: 150,
    fill: "#ffffff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 519,
    r: 5,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371,
    cy: 552,
    r: 12,
    fill: "none",
    stroke: "#9aa9b5",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 282V472",
    stroke: "#b7d4c6",
    strokeWidth: 5,
    opacity: 0.65
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 753,
    height: 565,
    fill: "none",
    stroke: "#b8c4cf",
    strokeWidth: 2,
    opacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericMap);
export default __webpack_public_path__ + "static/media/generic-map.628f0be3466e3c31d0935ee433917a6a.svg";
export { ForwardRef as ReactComponent };